/**
 * ============================================================================
 * USER / TENANT SERVICE: Media Assets & Storage Paths (`tbl_media` - Sheet 27)
 * ============================================================================
 * Purpose:
 *   Handles media asset records (images, videos, audio, documents) and
 *   queries Sheet 36 physical disk directory paths for the active tenant.
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import api from "../../core/services/api";
import { createCrudService } from "../../core/services/crudServiceFactory";

const baseMediaService = createCrudService("tenant/media");

const mediaService = {
  ...baseMediaService,

  /**
   * Retrieves tenant-scoped storage directory paths based on Sheet 36.
   *
   * @returns {Promise<Object>} { userRoot, conversationRoot, mediaRoot, currentMediaMonth }
   */
  getStoragePaths: () => {
    return api.get("/tenant/media-storage/info");
  },
};

export default mediaService;
